<template>
  <!--  <LazyItem @show="onShow">-->
  <div class="mic-com goods-tag-list">
    <component
      :is="tagName"
      :top="rect.top"
      :preview="preview"
      :config-list="configList"
      :sticky="!!config.tag_menu_position"
    />
    <div class="empty-image" v-if="!configList.length">
      <img :src="goods_empty" alt="" />
    </div>
  </div>
  <!--  </LazyItem>-->
</template>

<script>
import Common from "../mixins/Common";
import TagListLeft from "./TagListLeft";
import MenuList from "./MenuList";
import goods_empty from "@/assets/good_empty.png";

const scrollY = () =>
  window.hasOwnProperty("scrollY") ? window.scrollY : window.pageYOffset;
const toGuids = list => list.map(it => it.key).join();

export default {
  name: "goods_tag_list",
  props: {},
  mixins: [Common],
  components: { MenuList, TagListLeft },
  data() {
    return {
      configList: [],
      goods_empty,
      rect: {
        top: 1
      }
    };
  },
  created() {
    this.configList = this.goodsConfigList;
    this.throttleScroll = this.$utils.throttle(this.onScroll, 32);
  },
  methods: {
    onShow() {
      const rect = this.$el.getBoundingClientRect();
      this.rect = {
        top: rect.top,
        height: rect.height
      };
      this.lastTop = rect.top;
      this.lastY = scrollY();
    },
    onScroll(e) {
      const deltaY = scrollY() - this.lastY;
      this.rect.top = this.lastTop - deltaY;
    },
    visibleStateChange(state) {
      if (state === "show") {
        this.onShow();
        window.addEventListener("scroll", this.throttleScroll);
      }
      if (state === "hidden") {
        window.removeEventListener("scroll", this.throttleScroll);
      }
    },
    forceChildReload() {
      // goods组件中
      const tmp = {};
      this.configList = this.goodsConfigList.map(it => {
        tmp[it.key] = it.category_total_goods_number;
        return { ...it, category_total_goods_number: 0 };
      });

      setTimeout(() => {
        this.configList.forEach(
          it => (it.category_total_goods_number = tmp[it.key])
        );
      }, 50);
    }
  },
  computed: {
    goodsConfigList() {
      // 将sub_entry分解为对应个数的goods组件
      // 数据更新时,只有在影响商品数据变化时,才会拉取数据
      return this.config.sub_entry.map(cate => {
        const config = { ...this.config, key: cate.guid };
        config.goods_from = 1;
        config.category_total_goods_number = cate.total_goods_number;
        config.category_guid = cate.guid;
        config.category_title = cate.title;
        config.category_tag_name = cate.tag_name;
        config.goods_number = cate.goods_number;
        config.is_show_all = cate.is_show_all;
        config.show_all_btn = cate.show_all_btn;
        config.more_link_url = cate.more_link_url;
        config.guids = [];
        config.sub_entry = [];

        config.goods_category = { ...cate };
        return config;
      });
    },
    tagName() {
      return ["MenuList", "TagListLeft"][this.config.tag_menu_direction];
    }
  },
  watch: {
    goodsConfigList(now, old) {
      if (!this.preview) return;
      // guid没有发生变化(增减,排序),不使子组件获取数据
      if (toGuids(now) === toGuids(old)) {
        this.configList = now;
        return;
      }
      this.forceChildReload();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.throttleScroll);
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.goods-tag-list {
}
</style>
